import { Component, Input } from '@angular/core';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-cemetery-site-details-preview',
  standalone: true,
  imports: [
    LabelComponent,
    DatePipe
  ],
  templateUrl: './cemetery-site-details-preview.component.html'
})
export class CemeterySiteDetailsPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;

  @Input()
  public personData: boolean = false;
}
